<template>
  <L1>
    <template slot="slot_title">

      <Select v-if="page!=='出單機列表'" :defaultValue="restaurant" @input="restaurant=$event" :width="'500px'">
        <option :value="null">全域</option>
        <option v-for="(rest, r) in restaurants" :key="r" :value="rest">{{rest}}</option>
      </Select>
      <RT :options="['出單機列表', '多台標籤機設定', '指定機台印標籤設定']" :defaultValue="page" @input="page=$event"/></template>
    <template  v-if="page==='出單機列表'">
      <div class="escpos">
        <div>ESC/POS 出單機設定  <AddBtn :style="{width: '190px', whiteSpace: 'nowrap'}" :bg="'var(--color-checked)'" :icon="'add'" :text="'新增出單機'" @click="add=!add"/></div>
        <div class="ul">
          <div class="li" v-if="add">
            <input type="text" placeholder="名稱" v-model="name" :style="{width: '280px'}">
            <input type="text" v-model="str"  :style="{width: '400px'}" placeholder="vid,pid,encoding|tcp:ip:port:encoding">
            <button :style="{marginLeft: 'auto', maskImage: 'url(./svg/btn/add.svg)', backgroundColor: 'var(--color-checked)'}" @click="pushtolist"></button>
          </div>
          <div class="li" v-for="(printer, p) in printers" :key="p">
            <div>{{printer.name}}</div><div>{{printer.str}}</div>
            <button :style="{marginLeft: 'auto', backgroundImage: 'url(./svg/btn/del2.svg)', backgroundColor: 'transparent'}" @click="deleteItem={...printer, index: p}"></button>
          </div>
        </div>
      </div>
      <comfirmVue :show="!!deleteItem"  v-if="!!deleteItem" :label="'確認刪除'" :text='`確定要刪除"${deleteItem.name}"嗎?`' @confirm="remove(deleteItem.index)" @cancel="deleteItem=null"/>
    </template>
    <div class="sticker-container" v-else-if="page==='多台標籤機設定'">
      <StickerSetting @update="update" :printers="printers" :item="restaurantInfo['sticker_'+i]" v-for="i in 4" :key="i" :index="i"/>
    </div>
    <div v-else>
      <StickerSettingList :restaurant="restaurant" :info="restaurantInfo" @refresh="refresh"/>
    </div>
  </L1>
</template>

<script>
import { getapi, postapi } from '../../store/fetch'
import RT from '../../components/radio/r1.vue'
import AddBtn from '../../components/btn/round.vue'
import L1 from '../../components/layout/L1.vue'
import Select from '../../components/select.vue'
import StickerSetting from './sticker/name.vue'
import StickerSettingList from './sticker/List.vue'
import { mapState } from 'vuex'
export default {
  components: {
    L1, RT, AddBtn, Select, StickerSetting, StickerSettingList
  },
  data () {
    return {
      deleteItem: null,
      printers: [],
      name: null,
      str: null,
      add: false,
      page: '出單機列表',
      restaurant: null,
      restaurantInfo: null
    }
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    })
  },
  async mounted () {
    const r = await getapi('selections/printers')
    if (r) {
      this.printers = r
    } else {
      this.printers = []
    }
    this.restaurant = this.defaultStore || this.restaurants[0]
  },
  watch: {
    restaurant: {
      async handler () {
        if (this.restaurant) {
          this.restaurantInfo = await getapi(`restaurantSetting/${this.restaurant}`)
        }
      },
      immediate: true
    }
  },
  methods: {
    async refresh () {
      if (this.restaurant) {
        this.restaurantInfo = await getapi(`restaurantSetting/${this.restaurant}`)
      }
    },
    async update (ev) {
      if (this.restaurant) {
        const r = await postapi(`restaurantSetting/${this.restaurant}`, ev)
        this.restaurantInfo = r
      }
    },
    async pushtolist () {
      if (this.name && this.str) {
        this.printers.push({ name: this.name, str: this.str })
        await postapi('selections/printers', { key: 'optionsObj', data: this.printers })
        this.name = null
        this.str = null
        this.add = false
      }
    },
    async remove (index) {
      this.printers.splice(index, 1)
      await postapi('selections/printers', { key: 'optionsObj', data: this.printers })
      this.deleteItem = null
    }
  }

}
</script>

<style lang="scss" scoped>
.sticker-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  padding: 45px 80px;
  gap: 80px;
}
input[type=text] {
  border-radius: 3px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  height: 40px;
  padding-inline: 1em;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.1em;
  box-sizing: border-box;
  &::placeholder {
    color: #CACACA;
  }
}
.li {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: start;
  gap: 10px;
  // border-bottom: 1px solid var(--color-border);
  padding-block: 6px;
  padding-inline: 8px;
  letter-spacing: 1px;
  display: flex;
  width: 729px;
  padding: 10px 0px;
  align-items: center;
  gap: 10px;
  &>div:nth-child(1) {
    width: 280px;
    text-align: start;
  }
  button {
    width: 40px;
    height: 40px;
    font-size: 20px;
    background-repeat: no-repeat;
    background-position: center;
    mask-repeat: no-repeat;
    mask-position: center;
  }
}
.ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: flex-start;
  justify-content: flex-start;
  gap: .5em 8em;
  flex-wrap: wrap;
}
.escpos {
  width: 726px;
  align-self: flex-start;
  padding: 36px 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
  font-size: 20px;
  &>div:nth-child(1) {
    font-weight: 700;
    font-size: 25px;
    white-space: nowrap;
    color: var(--color-checked);
    letter-spacing: .1em;
    display: flex;
    align-items: center;
    gap: 20px;
    button {

    }
  }
}

</style>
